import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { useRealmApp } from '../RealmApp';

export const useItemModifiers = () => {
  const app = useRealmApp();
  const { itemModifiers, loading } = useAllItemModifiers(app.currentUser.id);
  return {
    loading,
    itemModifiers,
  };
};

function useAllItemModifiers(ownerId) {
  //
  const { data, loading, error } = useQuery(
    gql`
      query getItemModifiers($ownerId: String!) {
        itemModifiers(query: { owner_id: $ownerId }, limit: 0) {
          _id
          name
          modifiers {
            _id
            isQuantifiable
            name
            price
            toAdd
            toRemove
          }
          updateDatetime
          creationDatetime
        }
      }
    `,
    { variables: { ownerId } }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  //
  const itemModifiers = data?.itemModifiers ?? [];
  return { itemModifiers, loading };
}

export const useItemVariants = () => {
  const app = useRealmApp();
  const { itemVariants, loading } = useAllItemVariants(app.currentUser.id);
  return {
    loading,
    itemVariants,
  };
};

function useAllItemVariants(ownerId) {
  //
  const { data, loading, error } = useQuery(
    gql`
      query getItemVariants($ownerId: String!) {
        itemVariants(query: { owner_id: $ownerId }, limit: 0) {
          _id
          name
          variants {
            _id
            name
            color
            size
            items {
              name
              value
            }
          }
          updateDatetime
          creationDatetime
        }
      }
    `,
    { variables: { ownerId } }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  //
  const itemVariants = data?.itemVariants ?? [];
  return { itemVariants, loading };
}
